import OpenNewUser from 'actions/users/open_new_user';
import OpenUser from 'actions/users/open_user';
import OpenUsersAdmin from 'actions/users/open_users_admin';
import { registerUrlConverter } from './location_url';
import { removeEditableUser } from 'actions/users/lib/remove_editable_user';
import StaticUrlConverter from './url_converters/static_url_converter';
import UnloadUsersAdmin from 'actions/users/unload_users_admin';
import UserEditor from 'models/location/user_editor';
import UsersAdmin from 'models/location/users_admin';

registerUrlConverter(UsersAdmin, StaticUrlConverter.create('/users'));
registerUrlConverter(UserEditor, { getPath: ue => `/users/${ue.userId || 'new'}` });

export default function(router, { runnerContext }) {
  return {
    on: () => {
      runnerContext.executeAction(OpenUsersAdmin);
    },
    '/new': {
      on: () => {
        runnerContext.executeAction(OpenNewUser);
      },
      after: () => {
        removeEditableUser(runnerContext);
      },
    },
    '/:userId': {
      on: userId => {
        runnerContext.executeAction(OpenUser, userId);
      },
      after: () => {
        removeEditableUser(runnerContext);
      },
    },
    after() {
      if (!router.getPath().startsWith('/users') && !router.getPath().startsWith('/teams')) {
        runnerContext.executeAction(UnloadUsersAdmin);
      }
    },
  };
}



// WEBPACK FOOTER //
// ./src/scripts/adapters/routes/users_routes.js